import React, { useEffect, useState } from 'react';
import axios from 'axios';

const STORAGE_KEY = 'cookie_consent_v1';
const EXPIRY_DAYS = 365;

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [prefs, setPrefs] = useState({ necessary: true, analytics: false, marketing: false });
  const [expandedCookie, setExpandedCookie] = useState(null);
  const [content, setContent] = useState('');

  useEffect(() => {
    const fetchCookiePolicy = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_NODE_API_URL}/organization-details`
        );
        if (res.data?.data?.cookie_policy) {
          setContent(res.data.data.cookie_policy);
        }
      } catch (e) {
        console.error('Error loading cookie policy:', e);
      }
    };
    fetchCookiePolicy();
  }, []);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    let shouldShow = true;
    try {
      if (stored) {
        const data = JSON.parse(stored);
        const savedDate = new Date(data.timestamp);
        const expiryDate = new Date(savedDate.getTime() + EXPIRY_DAYS * 24 * 60 * 60 * 1000);
        if (new Date() < expiryDate) {
          setPrefs(data.prefs);
          shouldShow = false;
        } else {
          localStorage.removeItem(STORAGE_KEY);
        }
      }
    } catch {
      localStorage.removeItem(STORAGE_KEY);
    }
    if (shouldShow) setVisible(true);

    window.openCookieSettings = () => { setOpenSettings(true); setVisible(true); };
  }, []);

  const savePrefs = (next) => {
    const data = { prefs: next, timestamp: new Date().toISOString() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    setPrefs(next);
  };

  const acceptAll = () => { savePrefs({ necessary: true, analytics: true, marketing: true }); setVisible(false); setOpenSettings(false); setExpandedCookie(null); };
  const rejectAll = () => { savePrefs({ necessary: true, analytics: false, marketing: false }); setVisible(false); setOpenSettings(false); setExpandedCookie(null); };
  const saveSettings = () => { savePrefs(prefs); setVisible(false); setOpenSettings(false); setExpandedCookie(null); };
  const toggleCookieExpand = (id) => { setExpandedCookie(expandedCookie === id ? null : id); };

  if (!visible) return null;

  return (
    <div className="cookie-banner-overlay">
      <div className="cookie-banner">
        <button className="cookie-close" onClick={() => setVisible(false)} aria-label="Close">×</button>
        {!openSettings && (
          <div className="cookie-content">
            {content ? (
              <div dangerouslySetInnerHTML={{ __html: content }} />
            ) : (
              <p>By clicking "Accept All Cookies", you agree to the storage of strictly necessary cookies on your device to ensure the secure and reliable operation of the platform.</p>
            )}
            <div className="cookie-actions">
              <button className="btn-accept" onClick={acceptAll}>Accept All Cookies</button>
              <button className="btn-reject" onClick={rejectAll}>Reject All</button>
              <button className="btn-settings" onClick={() => setOpenSettings(true)}>Cookies Settings</button>
            </div>
          </div>
        )}

        {openSettings && (
          <div className="cookie-settings">
            <h4>Cookies Settings</h4>
            <div className="cookie-category">
              <div className="cookie-category-header" onClick={() => toggleCookieExpand('necessary')}>
                <button className="cookie-expand-btn">{expandedCookie === 'necessary' ? '−' : '+'}</button>
                <span className="cookie-category-title">Strictly Necessary Cookies</span>
                <span className="cookie-category-status">Always Active</span>
              </div>
              {expandedCookie === 'necessary' && (
                <div className="cookie-category-content">
                  <div className="cookie-item">
                    <div className="cookie-item-header"><strong>AWSALB</strong></div>
                    <div className="cookie-item-description">This cookie is set by the AWS Application Load Balancer (ALB). It ensures requests are routed consistently to the same backend server during a session, enabling session stickiness.</div>
                  </div>
                  <div className="cookie-item">
                    <div className="cookie-item-header"><strong>AWSALBCORS</strong></div>
                    <div className="cookie-item-description">This cookie works alongside AWSALB for handling cross-origin requests. It helps maintain stickiness when CORS requests are made to the load balancer.</div>
                  </div>
                </div>
              )}
            </div>
            <div className="cookie-actions">
              <button className="btn-accept" onClick={saveSettings}>Save Preferences</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
